import { JpxImage } from './jpx/jpx';

/**
 * Decodes JPEG 2000 bytes (JP2 container or raw J2K codestream) to a PNG data
 * URL the browser can render in an <img>. Returns null if decoding fails.
 *
 * Uses a vendored pure-JS decoder (no WASM); validated pixel-exact against
 * Pillow for RGB/grayscale, JP2 and codestream variants.
 */
export function jp2ToDataUrl(bytes: Uint8Array): string | null {
  try {
    const jpx = new JpxImage();
    jpx.parse(bytes);
    const { width, height, componentsCount: c } = jpx;
    const items = jpx.tiles[0]?.items;
    if (!width || !height || !items) {
      return null;
    }

    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d');
    if (!ctx) {
      return null;
    }
    const img = ctx.createImageData(width, height);
    const px = img.data;
    const n = width * height;
    for (let i = 0; i < n; i++) {
      let r: number;
      let g: number;
      let b: number;
      if (c === 1) {
        r = g = b = items[i];
      } else {
        r = items[i * c];
        g = items[i * c + 1];
        b = items[i * c + 2];
      }
      const o = i * 4;
      px[o] = r;
      px[o + 1] = g;
      px[o + 2] = b;
      px[o + 3] = 255;
    }
    ctx.putImageData(img, 0, 0);
    return canvas.toDataURL('image/png');
  } catch {
    return null;
  }
}
